import { HomePageProps, WithGlobalData } from '@domains/view';

import { BFFCookieClientClass } from '@api/client/bff';
import { MainPagePayload, MainPageResult } from '@api/protocol';

import { Home } from '@views/Home/Home';

export const getServerSideProps: BFF.GetPageServerSideProps<WithGlobalData<HomePageProps>> = async (
    context,
) => {
    const { req } = context;

    return BFFCookieClientClass<HomePageProps>({
        request: req,
    })
        .addToStack<MainPagePayload, MainPageResult>({
            prop: 'data',
            url: '/api/main_page',
        })
        .getServerProps();
};

export default Home;
